import React from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm, Controller } from 'react-hook-form';
import { z, name } from '~/common/utils/validations';
import { Button, Input } from '@ui-elements';
import { StepTwoValues } from '../../types';
import styles from './index.module.scss';

const schema = z.object({
  firstName: name('First name is empty or invalid'),
  lastName: name('Last name is empty or invalid'),
});

interface StepTwoProps {
  fontColor?: string;
  isSubmitting?: boolean;
  submitError?: boolean;
  onFinish: (values: StepTwoValues) => void;
}

export const StepTwo: React.FC<StepTwoProps> = ({
  fontColor,
  isSubmitting,
  submitError,
  onFinish,
}) => {
  const { control, handleSubmit, formState } = useForm<StepTwoValues>({
    resolver: zodResolver(schema),
    mode: 'onChange',
    defaultValues: { firstName: '', lastName: '' },
  });

  return (
    <div className={styles.StepTwo}>
      <h3 style={{ color: fontColor }}>
        You&apos;re all set - now let&apos;s make your experience even better
      </h3>

      <form onSubmit={handleSubmit(onFinish)}>
        <Controller
          name="firstName"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              className={styles.NameField}
              label="First name"
              error={formState.errors.firstName?.message}
              errorColor="#b00020"
            />
          )}
        />

        <Controller
          name="lastName"
          control={control}
          render={({ field }) => (
            <Input
              {...field}
              className={styles.NameField}
              label="Last name"
              error={formState.errors.lastName?.message}
              errorColor="#b00020"
            />
          )}
        />

        {submitError && (
          <p className={styles.Error}>
            Something went wrong, please try again.
          </p>
        )}

        <Button
          nativeType="submit"
          buttonSize="medium"
          disabled={!formState.isValid || isSubmitting}
          loading={isSubmitting}
        >
          Finish
        </Button>
      </form>

      <a
        href="/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.PrivacyPolicyLink}
        style={{ color: fontColor }}
      >
        Privacy Policy
      </a>
    </div>
  );
};
